// import React from "react";

// const Contact = () => {
//   return (
//     <>
//       <style>{`
//         .contact-cards-section {
//           background-color: #eaf5fd;
//           text-align: center;
//           padding: 4rem 2rem;
//         }

//         .contact-cards-section h3 {
//           font-size: 2rem;
//           margin-bottom: 3rem;
//           color: #1f2e45;
//         }

//         .card-container {
//           display: flex;
//           flex-wrap: wrap;
//           justify-content: center;
//           gap: 2rem;
//         }

//         .card {
//           background: white;
//           padding: 2rem;
//           border-radius: 15px;
//           box-shadow: 0 20px 50px rgba(0, 0, 0, 0.1);
//           width: 300px;
//           transition: transform 0.3s ease;
//         }

//         .card:hover {
//           transform: translateY(-5px);
//         }

//         .card-icon {
//           font-size: 2.5rem;
//           margin-bottom: 1rem;
//           color: #007bff;
//         }

//         .card h4 {
//           margin: 1rem 0 0.5rem;
//           color: #1f2e45;
//         }

//         .card p {
//           color: #555;
//           font-size: 0.95rem;
//         }

//         .card a {
//           display: inline-block;
//           margin-top: 1.2rem;
//           color: #007bff;
//           font-weight: bold;
//           text-decoration: none;
//         }

//         .card a:hover {
//           text-decoration: underline;
//         }

//         .contact-section {
//           position: relative;
//           background-color: #06014b;
//           color: white;
//           padding: 4rem 2rem;
//           overflow: hidden;
//         }

//         .overlay {
//           position: absolute;
//           top: 0;
//           right: 0;
//           width: 100%;
//           height: 100%;
//           background-image: radial-gradient(circle at center, transparent 20%, white 100%), 
//                             repeating-radial-gradient(circle at center, #f47b88 0, transparent 1px, transparent 2px);
//           background-size: cover;
//           opacity: 0.3;
//           mix-blend-mode: lighten;
//         }

//         .contact-container {
//           position: relative;
//           z-index: 2;
//           background-color: #06014b;
//           padding: 3rem;
//           border-radius: 15px;
//           max-width: 700px;
//           margin: 0 auto;
//           box-shadow: 0 0 30px rgba(0, 0, 0, 0.3);
//         }

//         .contact-container h2 {
//           font-size: 2.5rem;
//           margin-bottom: 1.5rem;
//           text-align: center;
//         }

//         .contact-form {
//           display: flex;
//           flex-direction: column;
//           gap: 1.2rem;
//         }

//         .contact-form input,
//         .contact-form textarea {
//           padding: 1rem;
//           border: none;
//           border-radius: 8px;
//           font-size: 1rem;
//         }

//         .contact-form textarea {
//           resize: vertical;
//           min-height: 120px;
//         }

//         .contact-form button {
//           background-color: transparent;
//           color: white;
//           border: 1px solid white;
//           padding: 0.8rem 1.5rem;
//           font-size: 1rem;
//           cursor: pointer;
//           border-radius: 5px;
//           transition: 0.3s ease;
//         }

//         .contact-form button:hover {
//           background-color: white;
//           color: #06014b;
//         }

//         @media (max-width: 768px) {
//           .contact-container {
//             padding: 2rem;
//           }

//           .contact-container h2 {
//             font-size: 2rem;
//           }

//           .card-container {
//             flex-direction: column;
//             align-items: center;
//           }
//         }
//       `}</style>

//       {/* Contact Cards Section */}
//       <section className="contact-cards-section">
//         <h3>Come, Join Us! We Will Show You The Exact Digital World.</h3>
//         <div className="card-container">
//           <div className="card">
//             <div className="card-icon">📞</div>
//             <h4>Sales</h4>
//             <p>
//               We put a strong focus on the needs of your business to figure out
//               solutions that best fit your demand and nail it.
//             </p>
//             <a href="#contact">Contact Sales</a>
//           </div>
//           <div className="card">
//             <div className="card-icon">🛠️</div>
//             <h4>Help & Support</h4>
//             <p>
//               Our preventive and progressive approach will help you take the
//               lead while addressing possible threats in managing data.
//             </p>
//             <a href="#contact">Get Help</a>
//           </div>
//           <div className="card">
//             <div className="card-icon">❓</div>
//             <h4>Enquiry</h4>
//             <p>
//               Our support team is available 24/7 and can get ready for solving
//               any of your situational rising problems.
//             </p>
//             <a href="#contact">Ask a Question</a>
//           </div>
//         </div>
//       </section>

//       {/* Contact Form Section */}
//       <section className="contact-section" id="contact">
//         <div className="overlay"></div>
//         <div className="contact-container">
//           <h2>Contact Us</h2>
//           <form className="contact-form">
//             <input type="text" placeholder="Your Name" required />
//             <input type="email" placeholder="Your Email" required />
//             <textarea placeholder="Your Message" required></textarea>
//             <button type="submit">SEND MESSAGE</button>
//           </form>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Contact;

// import React from 'react';

import React from 'react';

const Contact = () => {
  const bannerImage = '/Images/image27.jpeg';

  return (
    <div className="contact-page">
      <style jsx>{`
        .contact-page {
          font-family: 'Segoe UI', sans-serif;
          color: #111;
        }

        .contact-banner {
          position: relative;
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          height: 300px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          text-align: center;
          overflow: hidden;
        }

        .contact-banner::before {
          content: "";
          position: absolute;
          inset: 0;
          background-color: rgba(0, 0, 0, 0.5);
          backdrop-filter: blur(2px);
          z-index: 1;
        }

        .contact-banner .overlay-text {
          position: relative;
          z-index: 2;
          text-align: center;
          width: 100%;
          padding: 0 20px;
          box-sizing: border-box;
          animation: slideDownFade 1.5s ease-out forwards;
        }

        .contact-banner h2 {
          font-size: 42px;
          font-weight: bold;
          margin: 0;
          animation-delay: 0.3s;
        }

        @keyframes slideDownFade {
          0% { opacity: 0; transform: translateY(-40px); }
          100% { opacity: 1; transform: translateY(0); }
        }

        /* New Header Section */
        .contact-header {
          background: #ffffff;
          padding: 60px 20px;
          text-align: center;
        }

        .contact-title span {
          color: #0094ff;
          font-size: 33px;
          font-weight: bold;
          display: inline-block;
          margin-bottom: 2px;
        }

        .contact-title h1 {
          font-size: 32px;
          margin-bottom: 2px;
          color: black;
        }

        .contact-title p {
          font-size: 16px;
          color: black;
        }

        /* New Cards Section */
        .contact-info-cards {
          background: #0e2147;
          padding: 60px 20px;
        }

        .contact-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
}

.contact-card {
  background: white;
  color: black;
  flex: 1 1 250px; /* Sets minimum width of 250px */
  max-width: 300px; /* Ensures cards don't become too wide */
  padding: 20px;
  border-radius: 5px;
  transition: all 0.3s ease;
}


        .contact-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }

        .contact-icon {
          font-size: 36px;
          margin-bottom: 15px;
        }

        /* Contact Form Section */
        .contact-section {
          background: white;
          padding: 60px 20px;
          color: white;
        }

        .contact-container {
          max-width: 600px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          gap: 20px;
          padding: 40px;
          border-radius: 20px;
          background: #0e2147;
          backdrop-filter: blur(12px);
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
        }

        .contact-container h2 {
          font-size: 42px;
          margin-bottom: 20px;
          color: white;
        }

        .contact-container p {
          font-size: 18px;
          line-height: 1.7;
          color: white;
        }

        .contact-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .form-row {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .form-row input {
          flex: 1;
        }

        .contact-form input,
        .contact-form textarea {
          padding: 16px;
          border: none;
          border-radius: 12px;
          font-size: 1rem;
          color: #333;
          background: #fff;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        .contact-form input:focus,
        .contact-form textarea:focus {
          outline: none;
          box-shadow: 0 0 0 3px rgba(75, 0, 179, 0.4);
        }

        .contact-form textarea {
          min-height: 140px;
          resize: vertical;
        }

        .contact-form button {
          background-color: transparent;
          color: white;
          border: 1px solid white;
          padding: 0.8rem 1.5rem;
          font-size: 1rem;
          cursor: pointer;
          border-radius: 5px;
          transition: 0.3s ease;
        }

        .contact-form button:hover {
          background-color: white;
          color: #0e2147;
        }

        @media (min-width: 768px) {
          .contact-container {
            flex-direction: row;
            justify-content: space-between;
            align-items: flex-start;
          }

          .contact-info {
            flex: 1;
            padding-right: 40px;
          }

          .contact-form {
            flex: 1;
          }

          .form-row {
            flex-direction: row;
            gap: 20px;
          }
        }
      `}</style>

      {/* Banner */}
      <div
        className="contact-banner"
        style={{ backgroundImage: `url(${bannerImage})` }}
      >
        <div className="overlay-text">
          <h2>Contact Us</h2>
        </div>
      </div>

      {/* Contact Title & Description */}
      <section className="contact-header">
        <div className="contact-title">
          <span>Contact Us</span>
          <h1>We Are Ready For Your Help</h1>
          <p style={{ color: 'black' }}>
            We’d love to hear from you! Whether you have a project in mind,
            need expert guidance, or want to explore how our solutions can
            benefit your business, we are just a message or phone call away.
          </p>
        </div>
      </section>

      {/* Contact Info Cards */}
      <section className="contact-info-cards">
        <div className="contact-cards">
          <div className="contact-card">
            <div className="contact-icon">📞</div>
            <h3>Phone Number</h3>
            <p>+91 6361799717</p>
          </div>

          <div className="contact-card">
            <div className="contact-icon">✉️</div>
            <h3>Email Address</h3>
            <p>support@deepbrik.com</p>
          </div>

          <div className="contact-card">
            <div className="contact-icon">📍</div>
            <h3>Location</h3>
            <p>
              Bangalore <br />
              Karnataka, India
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="contact-section" id="contact">
        <div className="overlay" style={{ backgroundColor: 'black' }}></div>
        <div className="contact-container">
          <h2>Contact Us</h2>
          <form className="contact-form">
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Your Email" required />
            <textarea placeholder="Your Message" required></textarea>
            <button type="submit">SEND MESSAGE</button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Contact;

